import { createFileRoute } from "@tanstack/react-router";
import { TidsplanlaegningPage, tidsplanlaegningHead } from "@/pages/TidsplanlaegningPage";

export const Route = createFileRoute("/de/terminplanung")({
  head: () => tidsplanlaegningHead("de"),
  component: () => <TidsplanlaegningPage locale="de" />,
});
